import { render, staticRenderFns } from "./InvoiceImport.vue?vue&type=template&id=2ada4b45"
import script from "./InvoiceImport.vue?vue&type=script&lang=js"
export * from "./InvoiceImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports